import {
  SR_API_ACTION_LEASES_GET,
} from 'api/actionTypes';

export default async function getLeaseByListingId(
  { state, apiClient },
  { listingId }
) {
  const statePath = ['leases', 'byListingId', listingId];
  if (state.get(statePath)) {
    return state.get(statePath);
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_LEASES_GET,
    queryId: String(listingId),
    state: state,
    payload: {
      listingId: listingId,
    },
    onSuccess(lease) {
      state.set(statePath, lease);
    },
  });
}
